export const SET_UATRAITS = 'UATRAITS.SET_UATRAITS';
